<div fxLayout="row" fxLayoutAlign="center none">
  <div fxFlex.gt-sm="800px" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div fxLayout="column" fxFlexAlign="start">
          <h4>Personal details</h4>
          <table fxFlex="100" class="p-10">
            <tr>
              <td fxFlex="50">First Name</td>
              <td fxFlex="50">{{user.firstName}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Last Name</td>
              <td fxFlex="50">{{user.lastName}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Mobile</td>
              <td fxFlex="50">{{user.mobile}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Position</td>
              <td fxFlex="50">{{userPosition}}</td>
            </tr>
          </table>

          <h4 *ngIf="isNewCompany">Company details</h4>
          <table *ngIf="isNewCompany" fxFlex="100" class="p-10">
            <tr>
              <td fxFlex="50">Company Name</td>
              <td fxFlex="50">{{company.name}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Company Type</td>
              <td fxFlex="50">{{ companyType }}</td>
            </tr>
          </table>

          <h5 *ngIf="isNewCompany">Postal Address</h5>
          <table *ngIf="isNewCompany" fxFlex="100" class="p-10">
            <tr>
              <td fxFlex="50">Address Line 1</td>
              <td fxFlex="50">{{company.postalAddress?.line1}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Address Line 2</td>
              <td fxFlex="50">{{company.postalAddress?.line2}}</td>
            </tr>
            <tr>
              <td fxFlex="50">City</td>
              <td fxFlex="50">{{company.postalAddress?.city}}</td>
            </tr>
            <tr>
              <td fxFlex="50">State</td>
              <td fxFlex="50">{{company.postalAddress?.state}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Postal Code</td>
              <td fxFlex="50">{{company.postalAddress?.postalCode}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Country</td>
              <td fxFlex="50">{{company.postalAddress?.country}}</td>
            </tr>
          </table>

          <h5 *ngIf="isNewCompany">
            Street Address
          </h5>
          <p *ngIf="!company?.streetAddress && isNewCompany">Not provided</p>
          <table fxFlex="100" class="p-10" *ngIf="!!company?.streetAddress && isNewCompany">
            <tr>
              <td fxFlex="50">Address Line 1</td>
              <td fxFlex="50">{{company.streetAddress?.line1}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Address Line 2</td>
              <td fxFlex="50">{{company.streetAddress?.line2}}</td>
            </tr>
            <tr>
              <td fxFlex="50">City</td>
              <td fxFlex="50">{{company.streetAddress?.city}}</td>
            </tr>
            <tr>
              <td fxFlex="50">State</td>
              <td fxFlex="50">{{company.streetAddress?.state}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Postal Code</td>
              <td fxFlex="50">{{company.streetAddress?.postalCode}}</td>
            </tr>
            <tr>
              <td fxFlex="50">Country</td>
              <td fxFlex="50">{{company.streetAddress?.country}}</td>
            </tr>
          </table>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="p-t-20">
            <button mat-stroked-button color="basic" (click)="denyClick()">
              <mat-icon>clear</mat-icon> Deny
            </button>
            <button mat-flat-button color="primary" (click)="approveClick()">
              <mat-icon>done</mat-icon> Approve
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
